// extracted by mini-css-extract-plugin
module.exports = {"root":"EABD2App_root__2xgdo","embeddedRoot":"EABD2App_embeddedRoot__1CCSD"};